
import shared_stock_default from '../shared/DefaultStock'
import Api from '@/api/index';

const ModuleName = {
  namespaced: true,
  state: {
    value: 'my value',

    oneStock: null,
    allStocks: [],
    activeStocks: [],

  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneStock(state, stock){
      state.oneStock = stock // stock.data
    },
    setAllStocks(state, stocks){
      state.allStocks = stocks // stocks.data
    },
    setActiveStocks(state, stocks){
      state.activeStocks = stocks // stocks.data
    },

    updateFromManualStocks(state, stocks){
      let new_stocks = state.allStocks.map(as=> {
        let consolidated = null
        if (stocks.find(s=> Number(s.id) == Number(as.id))){
          consolidated = stocks.find(s=> Number(s.id) == Number(as.id)).consolidated
        } 
        return {...as, consolidated: consolidated || as.consolidated}
      })

      state.allStocks = [...new_stocks]
    },

    clearAllStocks(state){
      state.allStocks = null
    },
    clearActiveStocks(state){
      state.activeStocks = null
    },
    clearOneStock(state){
      state.oneStock = null
    },
  },

  actions: {
    clearAllStocks({commit}){
      commit('clearAllStocks')
    },
    clearOneStock({commit}){
      commit('clearOneStock')
    },

    index(context, filter) {
      // nao mt usado
      Api.Stock.index(filter).then(response => response.data).then(stocks => {
        context.commit('setAllStocks', stocks);
      }).catch(function(error) {
        console.log(error);
      });
    },
    indexByModel(context, {model = 'depots', id}) {
      // uso principal
      return Api.Stock.indexByModel({model, id}).then(response => response.data).then(stocks => {
        context.commit('setAllStocks', stocks);
        return true
      }).catch(function(error) {
        console.log(error);
      });
    },
    show(context, stock_id) {
      Api.Stock.show(stock_id).then(response => response.data).then(stock => {
        context.commit('setOneStock', stock);
      }).catch(function(error) {
        console.log(error);
      });
    },
    update(context, stock) {
      let notification = {}
      return Api.Stock.update(stock).then(response => response.data).then(stock => {
        // context.commit('setOneStock', stock); // not often used
        notification.type = 'success'
        notification.msg = 'Feito com sucesso'
        return stock
      }).catch(function(error) {
        console.log(error);
        notification.type = 'error'
        notification.msg = `Erro: ${error}`
        throw error
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },
    updateBatch(context, stock) {
      Api.Stock.updateBatch(stock).then(response => response.data).then(stock => {
        // context.commit('setOneStock', stock); // not often used
      }).catch(function(error) {
        console.log(error);
      });
    },


    indexMovement(filter){
      Api.Stock.indexMovement(filter).then(response => response.data).then(stocks => {
        context.commit('setAllStocks', stocks);
      }).catch(function(error) {
        console.log(error);
      });
    },

    createMovement(context, movement) {
      let notification = {}
      return Api.Stock.createMovement(movement).then(response => response.data).then(stock => {
        // context.commit('setOneStock', stock); // not often used
        notification.type = 'success'
        notification.msg = 'Feito com sucesso'
        return true
      }).catch(function(error) {
        console.log(error);
        notification.type = 'error'
        notification.msg = `Erro: ${err}`
        throw Error(error)
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    manualCount(context, manual_stocks) {
      let notification = {}
      return Api.Stock.manualCount(manual_stocks).then(response => response.data).then(stocks => {
        // if (stocks.updated_stocks){
        //   context.commit('updateFromManualStocks', stocks.updated_stocks);
        // }
        notification.type = 'success'
        notification.msg = 'Feito com sucesso'
        return stocks
      }).catch(function(error) {
        console.log(error);
        notification.type = 'error'
        notification.msg = `Erro: ${err}`
        throw Error(error)
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    manualCountComment(context, movements) {
      let notification = {}
      return Api.Stock.manualCountComment(movements).then(response => response.data).then(movements => {
        notification.type = 'success'
        notification.msg = 'Feito com sucesso'
        return movements
      }).catch(function(error) {
        console.log(error);
        notification.type = 'error'
        notification.msg = `Erro: ${err}`
        throw Error(error)
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },
  }

};

export default ModuleName;